import { get, put, post, del, patch } from "./lib/http";

function checkAuth(cb) {
    get("/online/auth", cb)
}
function logout(cb) {
    post("/online/auth/logout", {}, cb)
}

function getCustomers(cb) {
    get("/customer-portal/all", cb)
}

// Customer management (admin interface)
function getCustomer(customerId, cb) {
    get(`/customers/${customerId}`, cb)
}

function createCustomer(data, cb) {
    post('/customers', data, cb)
}

function updateCustomer(customerId, data, cb) {
    patch(`/customers/${customerId}`, data, cb)
}

function getCustomerHistory(customerId, cb) {
    get(`/customers/${customerId}/history`, cb)
}

function performCustomerAction(customerId, data, cb) {
    post(`/customers/${customerId}/actions`, data, cb)
}

function getProjects(cb) {
    get("/rest/projects", cb)
}
function getPickupProjects(cb) {
    get("/rest/projects?pickup=true", cb)
}

// Project management (admin interface)
function getProject(projectId, cb) {
    get(`/projects-admin/${projectId}`, cb)
}

function createProject(data, cb) {
    post('/projects-admin', data, cb)
}

function updateProject(projectId, data, cb) {
    patch(`/projects-admin/${projectId}`, data, cb)
}

function setProjectPermission(projectId, data, cb) {
    post(`/projects-admin/${projectId}/permissions`, data, cb)
}

function getAllProjects(cb) {
    get("/projects-admin/all", cb)
}

function mergeProject(projectId, data, cb) {
    post(`/projects-admin/${projectId}/merge`, data, cb)
}

function updateContractField(contractId, field, value, cb) {
    put("/tables/update-contract-field", {"id": contractId, "field": field, "value": value}, cb)
}

// Legacy functions for backward compatibility
function changeClassOfContract(contractId, newClass, cb) {
    updateContractField(contractId, "Klasse", newClass, cb)
}

function changeAbholzeitOfContract(contractId, field, value, cb) {
    updateContractField(contractId, field, value, cb)
}

function getProjectsForEating(cb) {
    get("/rest/projects?Essensangaben=true&Unteraccounts=true", cb)
}

function getAttendance(project, date, cb) {
    get("/attendance/" + project+"?date=" + date, cb)
}function setAttendance(attendance, cb){
    post("/attendance/update", attendance, cb)
}
function saveMealPlanForWeek(project, year, cw,mealplan,cb){
    put("/mealplan/"+project+"/"+year+cw, mealplan, cb)
}

function getMealPlanForWeek(project, year,cw,cb){
    get("/mealplan/"+project+"/"+year+cw,cb)
}

function getMealsForWeek(project, year,cw,cb){
    get("/mealplan2/"+project+"/"+year+cw,cb)
}

function exportBookingsForWeek(project, year,cw,cb){
    var req = new XMLHttpRequest()
    req.open("GET", process.env.VUE_APP_BE_URL + "/mealplan/export/"+project+"/"+year+cw,cb)
    req.withCredentials = true
    req.addEventListener('load', function (event) {
        cb(req)
    })
    req.onerror = function (event) {
        cb(req)
    }
    req.send()
}

function importMealplan(plan, cb){
    const formData= new FormData();
    formData.append("plan", plan);
    var req = new XMLHttpRequest()
    req.open("POST", process.env.VUE_APP_BE_URL + "/mealplan/import")
    req.withCredentials = true
    req.addEventListener('load', function (event) {
        try {
            let response = JSON.parse(req.responseText)
            cb(response, req.status)
        } catch (e) {
            cb(false, req.status)
        }
    })
    req.onerror = function (event) {
        cb(false, false)
    }
    req.send(formData)
}

function getChangeRequests(project, cb){
    get("/attendance/requests?project="+project, cb)
}

function getAllChangeRequests(project, cb){
    get("/attendance/requests/all?project="+project, cb)
}

function getDashboardStats(cb){
    get("/dashboard/stats", cb)
}

function getContractsStats(cb){
    get("/dashboard/contracts", cb)
}

function getProjectsStats(cb){
    get("/dashboard/projects", cb)
}

function getProjectsOverview(cb){
    get("/dashboard/projectsoverview", cb)
}

function getDashboardAnnouncements(cb){
    get("/dashboard/announcements", cb)
}

function getMealsStats(cb){
    get("/dashboard/meals", cb)
}

function acceptRequest(request, cb){
    post("/attendance/requests/"+request.id+"/accept", {comment:request.comment}, cb)
}

function declineRequest(request, cb){
    post("/attendance/requests/"+request.id+"/decline", {comment:request.comment}, cb)
}   

function getAttendanceDayException(project, date, cb) {
    get(`/attendance/attendanceDayException?project=${project}&date=${date}`, cb);
}

function createAttendanceDayException(data, cb) {
    post("/attendance/attendanceDayException", data, cb);
}

function updateAttendanceDayException(id, data, cb) {
    put(`/attendance/attendanceDayException/${id}`, data, cb);
}

function deleteAttendanceDayException(id, cb) {
    del(`/attendance/attendanceDayException/${id}`, {}, cb);
}

// Tables API
function getTableData(params, cb) {
    const query = new URLSearchParams(params).toString();
    get(`/tables/data?${query}`, cb);
}

function getTableColumns(type, cb) {
    const query = new URLSearchParams({ type }).toString();
    get(`/tables/columns?${query}`, cb);
}

function getFilterOptions(type, field, cb) {
    const query = new URLSearchParams({ type, field }).toString();
    get(`/tables/filter-options?${query}`, cb);
}

function getTableSums(params, cb){
    const query = new URLSearchParams(params).toString();
    get(`/tables/sums?${query}`, cb);
}

function exportTableCsv(params){
    const query = new URLSearchParams(params).toString();
    const url = `${process.env.VUE_APP_BE_URL}/tables/export?${query}`
    const a = document.createElement('a');
    a.href = url;
    a.target = '_blank';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
}

// Contract API functions
function getContract(contractId, cb) {
    get(`/contracts/${contractId}`, cb)
}

function updateContract(contractId, data, cb) {
    patch(`/contracts/${contractId}`, data, cb)
}

function createContract(data, cb) {
    post(`/contracts`, data, cb)
}

function deleteContract(contractId, cb) {
    del(`/contracts/${contractId}`, {}, cb)
}

function getContractDocuments(contractId, cb) {
    get(`/contracts/${contractId}/documents`, cb)
}

function getContractHistory(contractId, cb) {
    get(`/contracts/${contractId}/history`, cb)
}

function performContractAction(contractId, data, cb) {
    post(`/contracts/${contractId}/actions`, data, cb)
}

function getContractLastPickup(contractId, cb) {
    get(`/contractLastPickup/${contractId}`, cb);
}

function getContractEmails(params, cb) {
    const query = new URLSearchParams(params).toString();
    get(`/contracts/emails?${query}`, cb);
}

function getEssensinfos(params, cb) {
    const query = new URLSearchParams(params).toString();
    get(`/contracts/essensinfos?${query}`, cb);
}

function getContractSentMails(contractId, cb) {
    get(`/contracts/${contractId}/sent-mails`, cb);
}

function getCustomerSentMails(customerId, cb) {
    get(`/customers/${customerId}/sent-mails`, cb);
}

// Contacts API functions
function getContacts(params, cb) {
    const query = new URLSearchParams(params).toString();
    get(`/contacts?${query}`, cb);
}

function getContact(contactId, cb) {
    get(`/contacts/${contactId}`, cb);
}

function createContact(data, cb) {
    post('/contacts/create', data, cb);
}

function updateContact(contactId, data, cb) {
    put(`/contacts/${contactId}/update`, data, cb);
}

function importContactsCsv(file, cb) {
    const formData = new FormData();
    formData.append('file', file);
    
    var req = new XMLHttpRequest();
    req.open("POST", process.env.VUE_APP_BE_URL + "/contacts/import-csv");
    req.withCredentials = true;
    req.addEventListener('load', function (event) {
        try {
            let response = JSON.parse(req.responseText);
            cb(response, req.status);
        } catch (e) {
            cb(false, req.status);
        }
    });
    req.onerror = function (event) {
        cb(false, false);
    };
    req.send(formData);
}

function getContactsColumns(cb) {
    get('/contacts/columns', cb);
}

// Polls API functions
function getPolls(params, cb) {
    const query = new URLSearchParams(params).toString();
    get(`/polls?${query}`, cb);
}

function getPoll(pollId, cb) {
    get(`/polls/${pollId}`, cb);
}

function createPoll(data, cb) {
    post('/polls/create', data, cb);
}

function createPollGroup(data, cb) {
    post('/pollgroups/create', data, cb);
}

function updatePoll(pollId, data, cb) {
    put(`/polls/${pollId}/update`, data, cb);
}

function deletePoll(pollId, cb) {
    del(`/polls/${pollId}/delete`, {}, cb);
}

function deleteUmfragegruppe(groupId, cb) {
    del(`/pollgroups/${groupId}/delete`, {}, cb);
}

function createPollOption(pollId, data, cb) {
    post(`/polls/${pollId}/options/create`, data, cb);
}

function updatePollOption(pollId, optionId, data, cb) {
    put(`/polls/${pollId}/options/${optionId}/update`, data, cb);
}

function getUmfragegruppe(groupId, cb) {
    get(`/pollgroups/${groupId}`, cb);
}

function updateUmfragegruppe(groupId, data, cb) {
    put(`/pollgroups/${groupId}/update`, data, cb);
}

function deletePollOption(pollId, optionId, cb) {
    del(`/polls/${pollId}/options/${optionId}/delete`, {}, cb);
}

function exportPollResults(pollId) {
    const url = `${process.env.VUE_APP_BE_URL}/polls/${pollId}/export`;
    window.open(url, '_blank');
}

// Distribution Lists API functions
function getDistributionLists(cb) {
    get('/distribution-lists', cb);
}

function getDistributionList(listId, cb) {
    get(`/distribution-lists/${listId}`, cb);
}

function createDistributionList(data, cb) {
    post('/distribution-lists/create', data, cb);
}

function updateDistributionList(listId, data, cb) {
    put(`/distribution-lists/${listId}/update`, data, cb);
}

function deleteDistributionList(listId, cb) {
    del(`/distribution-lists/${listId}/delete`, {}, cb);
}

function generateRecipients(data, cb) {
    post('/distribution-lists/generate-recipients', data, cb);
}

function getProjectsForLists(cb) {
    get('/distribution-lists/projects', cb);
}

function sendAppNotification(data, cb) {
    post('/distribution-lists/send-notification', data, cb)
}

function getEhrenamtForms(customerId, cb) {
    get(`/customers/${customerId}/ehrenamt/forms`, cb)
}

function getEhrenamtAvailableForms(customerId, cb) {
    get(`/customers/${customerId}/ehrenamt/forms/available`, cb)
}

function getEhrenamtFormFields(formType, cb) {
    get(`/ehrenamt/forms/fields?form_type=${encodeURIComponent(formType)}`, cb)
}

function submitEhrenamtForm(customerId, data, cb) {
    post(`/customers/${customerId}/ehrenamt/forms/submit`, data, cb)
}

function deleteEhrenamtForm(formId, cb) {
    del(`/ehrenamt/forms/${formId}/delete`, cb)
}

function getProjectParticipationRequests(projectId, cb) {
    get(`/ehrenamt/projects/${projectId}/participation-requests`, cb)
}

function updateParticipationRequestStatus(requestId, data, cb) {
    put(`/ehrenamt/participation/${requestId}/status`, data, cb)
}

export default {
    checkAuth,
    logout,
    getProjects,
    getPickupProjects,
    // Projects (admin)
    getProject,
    createProject,
    updateProject,
    setProjectPermission,
    getAllProjects,
    mergeProject,
    getAttendance,
    setAttendance,
    getProjectsForEating,
    importMealplan,
    saveMealPlanForWeek,
    getMealPlanForWeek,
    getMealsForWeek,
    exportBookingsForWeek,
    updateContractField,
    changeClassOfContract,
    changeAbholzeitOfContract,
    getChangeRequests,
    getAllChangeRequests,
    acceptRequest,
    declineRequest,
    getDashboardStats,
    getContractsStats,
    getProjectsStats,
    getProjectsOverview,
    getDashboardAnnouncements,
    getMealsStats,
    getAttendanceDayException,
    createAttendanceDayException,
    updateAttendanceDayException,
    deleteAttendanceDayException,
    // tables
    getTableData,
    getTableColumns,
    getFilterOptions,
    getTableSums,
    exportTableCsv,
    // contracts
    getContract,
    updateContract,
    createContract,
    deleteContract,
    getContractDocuments,
    getContractHistory,
    getContractLastPickup,
    performContractAction,
    getCustomers,
    // Customer management
    getCustomer,
    createCustomer,
    updateCustomer,
    getCustomerHistory,
    performCustomerAction,
    // Contacts
    getContacts,
    getContact,
    createContact,
    updateContact,
    importContactsCsv,
    getContactsColumns,
    // Polls
    getPolls,
    getPoll,
    createPoll,
    createPollGroup,
    updatePoll,
    deletePoll,
    deleteUmfragegruppe,
    createPollOption,
    updatePollOption,
    deletePollOption,
    exportPollResults,
    getUmfragegruppe,
    updateUmfragegruppe,
    // Distribution Lists
    getDistributionLists,
    getDistributionList,
    createDistributionList,
    updateDistributionList,
    deleteDistributionList,
    generateRecipients,
    getProjectsForLists,
    sendAppNotification,
    getEhrenamtForms,
    getEhrenamtAvailableForms,
    getEhrenamtFormFields,
    submitEhrenamtForm,
    deleteEhrenamtForm,
    getProjectParticipationRequests,
    updateParticipationRequestStatus,
    getSondertage,
    createSondertag,
    updateSondertag,
    deleteSondertag,
    getContractEmails,
    getEssensinfos,
    getContractSentMails,
    getCustomerSentMails,
    // Employees
    getEmployees,
    getEmployeeOptions,
    getEmployee,
    createEmployee,
    updateEmployee,
    deleteEmployee,
    // Accounts (Accounthilfe)
    getCredentialsList,
    activateAccount,
    resetPassword,
    mergeAccounts,
    searchCustomers,
    // Import
    getImportFields,
    importCsv,
    // Announcements admin
    getAdminAnnouncements,
    createAnnouncement,
    updateAnnouncement,
    deleteAnnouncement,
    uploadAnnouncementImage,
    // Permissions
    getPermissionUsers,
    getPermissions,
    updatePermissions,
    deletePermissions,
    // Exports
    getExportOptions,
    runExport,
    // Newsletter
    getNewsletter,
    updateNewsletter,
    previewNewsletter,
    prepareNewsletterSend,
    confirmNewsletterSend,
    getNewsletterProjects,
    // Maintenance admin
    getMaintenanceStatus,
    toggleMaintenance,
}

// Employees API functions
function getEmployees(cb) {
    get('/employees', cb)
}
function getEmployeeOptions(cb) {
    get('/employees/options', cb)
}
function getEmployee(employeeId, cb) {
    get(`/employees/${employeeId}`, cb)
}
function createEmployee(data, cb) {
    post('/employees/create', data, cb)
}
function updateEmployee(employeeId, data, cb) {
    put(`/employees/${employeeId}/update`, data, cb)
}
function deleteEmployee(employeeId, cb) {
    del(`/employees/${employeeId}/delete`, {}, cb)
}

// Accounts API functions (Accounthilfe)
function getCredentialsList(cb) {
    get('/accounts/credentials', cb)
}
function activateAccount(mail, cb) {
    post('/accounts/activate', { mail }, cb)
}
function resetPassword(mail, cb) {
    post('/accounts/reset-password', { mail }, cb)
}
function mergeAccounts(oldId, currentId, cb) {
    post('/accounts/merge', { old: oldId, current: currentId }, cb)
}
function searchCustomers(query, cb) {
    get(`/accounts/search-customers?q=${encodeURIComponent(query)}`, cb)
}

// Import API functions
function getImportFields(cb) {
    get('/import/fields', cb)
}
function importCsv(file, kind, cb) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('kind', kind);
    var req = new XMLHttpRequest();
    req.open("POST", process.env.VUE_APP_BE_URL + "/import/csv");
    req.withCredentials = true;
    req.addEventListener('load', function (event) {
        try {
            let response = JSON.parse(req.responseText);
            cb(response, req.status);
        } catch (e) {
            cb(false, req.status);
        }
    });
    req.onerror = function (event) {
        cb(false, false);
    };
    req.send(formData);
}

// Announcements admin API functions
function getAdminAnnouncements(cb) {
    get('/announcements/admin', cb)
}
function createAnnouncement(data, cb) {
    post('/announcements/admin/create', data, cb)
}
function updateAnnouncement(announcementId, data, cb) {
    put(`/announcements/admin/${announcementId}`, data, cb)
}
function deleteAnnouncement(announcementId, cb) {
    del(`/announcements/admin/${announcementId}/delete`, {}, cb)
}
function uploadAnnouncementImage(announcementId, file, cb) {
    const formData = new FormData();
    formData.append('image', file);
    var req = new XMLHttpRequest();
    req.open("POST", process.env.VUE_APP_BE_URL + `/announcements/admin/${announcementId}/image`);
    req.withCredentials = true;
    req.addEventListener('load', function (event) {
        try {
            let response = JSON.parse(req.responseText);
            cb(response, req.status);
        } catch (e) {
            cb(false, req.status);
        }
    });
    req.onerror = function (event) {
        cb(false, false);
    };
    req.send(formData);
}

// Permissions API functions
function getPermissionUsers(cb) {
    get('/permissions/users', cb)
}
function getPermissions(mail, cb) {
    get(`/permissions/${encodeURIComponent(mail)}`, cb)
}
function updatePermissions(mail, data, cb) {
    put(`/permissions/${encodeURIComponent(mail)}/update`, data, cb)
}
function deletePermissions(mail, cb) {
    del(`/permissions/${encodeURIComponent(mail)}/delete`, {}, cb)
}

// Exports API functions
function getExportOptions(cb) {
    get('/exports/options', cb)
}
function runExport(data, cb) {
    var req = new XMLHttpRequest();
    req.open("POST", process.env.VUE_APP_BE_URL + "/exports/run");
    req.withCredentials = true;
    req.setRequestHeader("Content-Type", "application/json");
    req.responseType = "blob";
    req.addEventListener('load', function (event) {
        if (req.status === 200) {
            var disposition = req.getResponseHeader('Content-Disposition');
            var filename = 'export';
            if (disposition) {
                var match = disposition.match(/filename=([^;\s]+)/);
                if (match) filename = match[1];
            }
            var blob = new Blob([req.response]);
            var url = window.URL.createObjectURL(blob);
            var a = document.createElement('a');
            a.href = url;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            window.URL.revokeObjectURL(url);
            cb(true, req.status);
        } else {
            cb(false, req.status);
        }
    });
    req.onerror = function (event) {
        cb(false, false);
    };
    req.send(JSON.stringify(data));
}

// Newsletter API functions
function getNewsletter(cb) {
    get('/newsletter', cb)
}
function updateNewsletter(data, cb) {
    put('/newsletter/update', data, cb)
}
function previewNewsletter(data, cb) {
    post('/newsletter/preview', data, cb)
}
function prepareNewsletterSend(data, cb) {
    post('/newsletter/prepare-send', data, cb)
}
function confirmNewsletterSend(data, cb) {
    post('/newsletter/send', data, cb)
}
function getNewsletterProjects(cb) {
    get('/newsletter/projects', cb)
}

// Maintenance admin API functions
function getMaintenanceStatus(cb) {
    get('/maintenance/status', cb)
}
function toggleMaintenance(data, cb) {
    post('/maintenance/toggle', data, cb)
}

function getSondertage(projectId, cb) {
    get(`/sondertage/${projectId}`, cb)
}
function createSondertag(projectId, data, cb) {
    post(`/sondertage/${projectId}`, data, cb)
}
function updateSondertag(projectId, sondertag_id, data, cb) {
    patch(`/sondertage/${projectId}/${sondertag_id}`, data, cb)
}
function deleteSondertag(projectId, sondertag_id, cb) {
    del(`/sondertage/${projectId}/${sondertag_id}`, null, cb)
}

function generateRequestId(message) {
    let hashValue = 0
    for (let i = 0; i < message.length; i++) {
        let charCode = message.charCodeAt(i);
        hashValue = ((hashValue << 5) - hashValue) + charCode;
        hashValue = hashValue & hashValue; // Ensure 32-bit integer limit
    }

    hashValue = hashValue >>> 0; // Convert to unsigned 32-bit integer
    console.log(hashValue.toString(16).padStart(8, '0'));
    return hashValue.toString(16).padStart(8, '0');
}